// Linear interpolation where alpha 0 corresponds to start and 1 to end
export default function lerp(start: number, end: number, alpha: number): number {
  return start * (1 - alpha) + end * alpha;
}
